import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import SecondaryButton from "web/react/components/buttons/secondary-button/secondary-button";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import globals from "web/script/modules/globals";
import cookie from "web/script/utils/cookie";
import styles from "./cookie-banner.css";

const consentCookieName = "cookieconsent";
const consentCookiePeriod = 365;
function setConsentCookie() {
    let hostnameParts = globals.window.location.hostname.split(".");
    let cookieDomain;
    if (hostnameParts.includes("www") || hostnameParts.includes("checkout")) {
        cookieDomain = hostnameParts.slice(1).join(".");
    }

    cookie(consentCookieName, 1, {
        expires: consentCookiePeriod,
        path: "/",
        withEncoding: false,
        domain: cookieDomain,
    });
}

function hasConsentCookie() {
    return Boolean(cookie(consentCookieName));
}

export function CookieBanner({ cookiePolicyUrl, debug, position, closeButton }) {
    let [showBanner, setShowBanner] = useState(false);

    function hideNotification() {
        setShowBanner(false);
        setConsentCookie();
        analytics.event("Cookie consent", "Clicked", "Hide");
    }

    useEffect(() => {
        if (debug || !hasConsentCookie()) {
            analytics.event("Cookie consent", "Shown", null, true);
            setShowBanner(true);
        }
    }, [debug]);

    let cookieText = gettext("cookie_notification.description_v2");

    return (
        <React.Fragment>
            {showBanner && (
                <div
                    className={classnames(styles.wrapper, {
                        [styles.top]: position == "top",
                        [styles.bottom]: position == "bottom",
                    })}
                >
                    <div
                        className={classnames(styles.container, {
                            [styles.verticalContainer]: closeButton == "button",
                        })}
                    >
                        <div className={styles.content}>
                            <p className={styles.text}>
                                {cookieText}{" "}
                                <a className={styles.readMore} href={cookiePolicyUrl}>
                                    {gettext("general.read_more")}
                                </a>
                            </p>
                        </div>
                        {closeButton === "cross" && (
                            <div onClick={hideNotification} className={styles.closeIcon}>
                                <SVGIcon name="cross" className={styles.iconInner} />
                            </div>
                        )}

                        {closeButton === "button" && (
                            <div onClick={hideNotification} className={styles.closeButton}>
                                <SecondaryButton fullHeight fullWidth>
                                    {gettext("general.accept")}
                                </SecondaryButton>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

CookieBanner.defaultProps = {
    // Force the banner to be visible for development.
    debug: false,
    position: "bottom",
    closeButton: "cross",
};
CookieBanner.propTypes = {
    cookiePolicyUrl: PropTypes.string.isRequired,
    debug: PropTypes.bool,
    position: PropTypes.oneOf(["top", "bottom"]),
    closeButton: PropTypes.oneOf(["cross", "button"]),
};
export default CookieBanner;
